angular.module('SpidApp')

.constant('MoneyTransferAdapterConfig', {
  name : 'MoneyTransfer',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'from',
    	distant : 'from'
    }, {
    	local   : 'to',
    	distant : 'to'
    }, {
    	local   : 'amount',
    	distant : 'amount'
    }, {
    	local   : 'destination',
    	distant : 'destination'
    }, {
    	local   : 'current',
    	distant : 'current'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }, {
    	local   : 'user_id',
    	distant : 'user_id'
    }, {
    	local   : 'agency_id',
    	distant : 'agency_id'
    }
  ]
})
